import { createRoute } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { rootRoute } from "../../root-route";
import { CartePubliquePage } from "./publique";

/**
 * La route publique d'une carte : `/c/<numero>-<edition>`, sans session. L'adresse est a n'importe qui : `ref` est
 * lu comme du texte et confronte par le serveur a sa forme (une adresse mal formee y rend 400, et la page dit alors
 * « Cette carte n'existe pas »).
 */
export const carteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/c/$ref",
  component: CarteRoute,
});

function CarteRoute(): ReactElement {
  const { ref } = carteRoute.useParams();
  return <CartePubliquePage reference={ref} />;
}
